import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContabilidadLayout } from '../../common/ContabilidadLayout';

import { DetalleCuentaDatosFijos } from './DetalleCuentaDatosFijos';
import { DetalleCuentaKPIs } from './DetalleCuentaKPIs';
import { DetalleCuentaGrafica } from './DetalleCuentaGrafica';
import { DetalleCuentaPDFs } from './DetalleCuentaPDFs';
import { DetalleCuentaMovimientos } from './DetalleCuentaMovimientos';

const DetalleCuentaBancariaContent = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    
    // Estados mockeados para el demo
    const [anioSeleccionado, setAnioSeleccionado] = useState(new Date().getFullYear().toString());
    const [cargando, setCargando] = useState(true);

    // Datos inventados (mock)
    const mockData = {
        '2025': {
            ingresos: [15000, 20000, 18000, 22000, 25000, 30000, 28000, 26000, 31000, 35000, 40000, 45000],
            egresos: [10000, 15000, 12000, 18000, 20000, 25000, 22000, 21000, 26000, 28000, 30000, 35000],
            saldoActual: 154000,
            ingresosMes: 45000,
            egresosMes: 35000,
            pendientes: 8,
            nombreBanco: 'BBVA - Principal',
            numCta: '0123456789',
            clabe: '012345678901234567',
            moneda: 'MXN',
            titular: 'Mi Empresa S.A. de C.V.',
            swift: 'BBVAMXMMXXX',
            stripeActivo: true
        },
        '2026': {
            ingresos: [12000, 19000, 21000, 25000, 28000, 31000, 32000, 35000, 40000, 42000, 48000, 50000],
            egresos: [11000, 16000, 15000, 19000, 22000, 23000, 28000, 30000, 32000, 35000, 38000, 41000],
            saldoActual: 245000,
            ingresosMes: 50000,
            egresosMes: 41000,
            pendientes: 12,
            nombreBanco: 'BBVA - Principal',
            numCta: '9876543210',
            clabe: '987654321098765432',
            moneda: 'MXN',
            titular: 'Mi Empresa S.A. de C.V.',
            swift: 'BBVAMXMMXXX',
            stripeActivo: true
        }
    };

    const dataActual = mockData[anioSeleccionado] || mockData['2026'];

    useEffect(() => {
        // Simular carga
        setCargando(true);
        setTimeout(() => setCargando(false), 500);
    }, [anioSeleccionado, id]);



    return (
        <Card className="shadow-sm border-0">
            <Card.Body className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <Button variant="link" className="text-decoration-none text-muted p-0 mb-2" onClick={() => navigate(-1)}>
                            <FontAwesomeIcon icon="arrow-left" className="me-2" />
                            Volver a cuentas
                        </Button>
                        <h4 className="fw-bold mb-0 text-dark">
                            Detalle de Cuenta: <span className="text-primary">{dataActual.nombreBanco}</span>
                        </h4>
                        <small className="text-muted">ID de Cuenta: {id}</small>
                    </div>
                    <div style={{ width: '150px' }}>
                        <Form.Group>
                            <Form.Label className="small text-muted fw-bold mb-1">Año Fiscal</Form.Label>
                            <Form.Select 
                                value={anioSeleccionado} 
                                onChange={(e) => setAnioSeleccionado(e.target.value)}
                            >
                                <option value="2025">2025</option>
                                <option value="2026">2026</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                </div>

                {/* Datos Fijos de la Cuenta */}
                <DetalleCuentaDatosFijos dataActual={dataActual} />

                {/* KPIs */}
                <DetalleCuentaKPIs dataActual={dataActual} />

                {/* Gráfica y PDFs */}
                <Row className="mb-5 g-3">
                    <Col lg={8}>
                        <DetalleCuentaGrafica anioSeleccionado={anioSeleccionado} cargando={cargando} dataActual={dataActual} />
                    </Col>
                    <Col lg={4}>
                        <DetalleCuentaPDFs />
                    </Col>
                </Row>

                {/* Movimientos */}
                <DetalleCuentaMovimientos />
            </Card.Body>
        </Card>
    );
};

const DetalleCuentaBancaria = () => {
    return (
        <ContabilidadLayout
            title={<><i className="fas fa-chart-line me-2" />Detalle de Cuenta</>}
        >
            <DetalleCuentaBancariaContent />
        </ContabilidadLayout>
    );
};

export default DetalleCuentaBancaria;
